"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function childClassClosure(baseClass) {
  return function (name) {
    var modifiers = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      modifiers[_i - 1] = arguments[_i];
    }

    var base = baseClass + "__" + name;
    if (modifiers.filter(function (x) {
      return x && x.length > 0;
    }).length == 0) return base;
    var modifiersString = modifiers.map(function (mod) {
      return base + "--" + mod;
    }).join(' ');
    return base + " " + modifiersString;
  };
}

exports.childClassClosure = childClassClosure;

function childClassClosureMultiple(baseClasses) {
  return function (name) {
    var modifiers = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      modifiers[_i - 1] = arguments[_i];
    }

    var result = [];
    var usedModifiers = modifiers.filter(function (x) {
      return x.length > 0;
    });

    var _loop_1 = function _loop_1(baseClass) {
      var base = baseClass + "__" + name;

      if (usedModifiers.length == 0) {
        result.push(base);
      } else {
        var modifiersString = usedModifiers.map(function (mod) {
          return base + "--" + mod;
        }).join(' ');
        result.push(base + " " + modifiersString);
      }
    };

    for (var _a = 0, baseClasses_1 = baseClasses; _a < baseClasses_1.length; _a++) {
      var baseClass = baseClasses_1[_a];

      _loop_1(baseClass);
    }

    return result.join(' ');
  };
}

exports.childClassClosureMultiple = childClassClosureMultiple;

function baseClassAnd(baseClass, andProps) {
  var modifiers = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    modifiers[_i - 2] = arguments[_i];
  }

  var result = [];
  var usedModifiers = modifiers.filter(function (x) {
    return x.length > 0;
  });

  if (andProps.className) {
    result.push(andProps.className);

    for (var _a = 0, usedModifiers_1 = usedModifiers; _a < usedModifiers_1.length; _a++) {
      var modifier = usedModifiers_1[_a];
      result.push(andProps.className + "--" + modifier);
    }
  }

  result.push(baseClass);

  for (var _b = 0, usedModifiers_2 = usedModifiers; _b < usedModifiers_2.length; _b++) {
    var modifier = usedModifiers_2[_b];
    result.push(baseClass + "--" + modifier);
  }

  return result.join(' ');
}

exports.baseClassAnd = baseClassAnd;